import _ from 'lodash';
import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Orders from './views/dashboard/orders/Orders.vue'
import OrderDetails from './views/dashboard/order-details/OrderDetails.vue'
import vuexStore from '@/store'

Vue.use(Router)

const publicPages = ['/']

const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // --- example --- for reference only - REMOVE AFTER DEVELOPMENT
    // {
    //   path: '/example-home',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    // --- example --- for reference only - REMOVE AFTER DEVELOPMENT
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      children: [
        {
          path: 'orders',
          component: Orders,
          name: 'dashboard-orders'
        },
        {
          path: 'orders/:orderId',
          component: OrderDetails,
          name: 'dashboard-order-detail'
        }
      ]
    },

    { path: '*', redirect: '/' },
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // eslint-disable-next-line
  let isLogged = _.get(vuexStore, 'getters.security/isLogged', false);
  const authRequired = !publicPages.includes(to.path);
  
  if (authRequired && !isLogged) {
    return next({name: 'login'});
  }

  next();
})

export default router;
